(window["webpackJsonpmeg_ui"] = window["webpackJsonpmeg_ui"] || []).push([["alert~collapse~config-provider~dropdown~empty~form~grid~index~input~input-number~loading~menu~modal~~0071d155"],{

/***/ 15:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var utils_vue_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var _default__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var moment__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(moment__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var utils_interopDefault__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'LocaleReceiver',
  props: {
    componentName: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].string.def('global'),
    defaultLocale: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].oneOfType([utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].object, utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func]),
    children: utils_vue_types__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].func
  },
  inject: {
    localeData: {
      default: function _default() {
        return {};
      }
    }
  },
  methods: {
    getLocale: function getLocale() {
      var componentName = this.componentName,
          defaultLocale = this.defaultLocale;
      var locale = defaultLocale || _default__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"][componentName || 'global'];
      var antLocale = this.localeData.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _objectSpread(_objectSpread({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    },
    getLocaleCode: function getLocaleCode() {
      var antLocale = this.localeData.antLocale;

      if (!antLocale) {
        Object(utils_interopDefault__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"])(moment__WEBPACK_IMPORTED_MODULE_2__).locale('zh_CN');
      }

      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

      if (antLocale && antLocale.exist && !localeCode) {
        return _default__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].locale;
      }

      return localeCode;
    }
  },
  render: function render() {
    var $scopedSlots = this.$scopedSlots;
    var children = this.children || $scopedSlots.default;
    var antLocale = this.localeData.antLocale;
    return children(this.getLocale(), this.getLocaleCode(), antLocale);
  }
});

/***/ }),

/***/ 43:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _locale_zh_CN__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);

/* harmony default export */ __webpack_exports__["a"] = (_locale_zh_CN__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/***/ })

}]);